import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import HowItWorks from '../components/HowItWorks';
import EntryPricing from '../components/EntryPricing';
import MonthlyPlans from '../components/MonthlyPlans';
import Trust from '../components/Trust';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Services />
      <WhyUs />
      <HowItWorks />
      <EntryPricing />
      <MonthlyPlans />
      <Trust />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;